export const clickEvent = (data = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "click", {
      ...data,
      pathname: window.location.pathname,
    })
  }
}
